import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames';
import * as React from 'react';
import { SliderContext } from '../../utils/sliderContext';
import { useSliderContextBuilder } from '../../utils/useSliderContextBuilder';
import * as styles from './Slider.css';
import { EventManager } from './components/EventManager';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SliderComponent = function SliderComponent(_ref, ref) {
  var _classNames;

  var loop = _ref.loop,
      _ref$flexDirection = _ref.flexDirection,
      flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
      children = _ref.children,
      onSlideChange = _ref.onSlideChange;
  var sliderContext = useSliderContextBuilder({
    loop: loop
  });
  React.useImperativeHandle(ref, function () {
    return sliderContext;
  }, [sliderContext]);
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles['container'], (_classNames = {}, _defineProperty(_classNames, styles['container--column'], flexDirection === 'column'), _defineProperty(_classNames, styles['container--row'], flexDirection === 'row'), _classNames)),
    children: /*#__PURE__*/_jsxs(SliderContext.Provider, {
      value: sliderContext,
      children: [/*#__PURE__*/_jsx(EventManager, {
        onSlideChange: onSlideChange
      }), children]
    })
  });
};

export var Slider = /*#__PURE__*/React.forwardRef(SliderComponent);